import { prepareMemberCommon, } from './prepare-member-common';
export const prepareGuestLinkMember = async (params) => {
    const { member } = await prepareMemberCommon(params);
    return member;
};
